import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

const LocationsForm = ({ locations, onAdd, onRemove, selectableLocations }) => {
  // prettier-ignore
  const handleChange = R.ifElse(
    R.includes(R.__, locations), 
    onRemove, 
    onAdd
  );
  return (
    <>
      <Box pb={3}>
        <Box>
          <Typography sx={{ m: 2 }}>
            {R.isEmpty(selectableLocations) ? 'No Locations Available' : 'Available Locations'}
          </Typography>
        </Box>
        {selectableLocations.map(selectableLocation => {
          const labelId = `checkbox-list-label-${selectableLocation.locationId}`;
          return (
            <Fragment key={selectableLocation.locationId}>
              <ListItem disablePadding key={selectableLocation.locationId}>
                <ListItemButton
                  dense
                  onClick={() => handleChange(selectableLocation)}
                  role={undefined}
                  sx={{ px: 3 }}
                >
                  <ListItemIcon sx={{ minWidth: 0 }}>
                    <Checkbox
                      checked={R.includes(selectableLocation, locations)}
                      disableRipple
                      edge="start"
                      tabIndex={-1}
                    />
                  </ListItemIcon>
                  <ListItemText
                    id={labelId}
                    primary={`${selectableLocation.locationId} ${selectableLocation.name}`}
                  />
                </ListItemButton>
              </ListItem>
              <Divider />
            </Fragment>
          );
        })}
      </Box>
    </>
  );
};

LocationsForm.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  selectableLocations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default LocationsForm;
